module.exports = __webpack_public_path__ + "alert.png?157bb267636f5b2fe29e415b43706aa1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-icons/alert.png
// module id = 488
// module chunks = 0